import React from 'react';
import DOMPurify from 'dompurify'
import globalStoreService from '../../services/global-store.service';
import BotType from '../../enums/BotType';

function ChatResponse({ message, messageTime, hide_logo }) {


    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        // set all elements owning target to target=_blank
        if (node.hasAttribute('href')) {
            node.setAttribute('target', '_blank');
        }
    });

    return (
        <div>
            <span className={(globalStoreService.get("currentBotType") === BotType.PAYMENTS_BANK) ? "arya new paymentsbank" : "arya new"} style={{ visibility: (hide_logo) ? 'hidden' : 'visible' }}>
            </span>
            <ul className="bubbles relate">
                {message &&
                    <div>
                        <li>
                            <p
                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message, { ALLOW_UNKNOWN_PROTOCOLS: true }) }} />
                            <span className="time">{messageTime && messageTime.time_in_format}</span>
                        </li>
                    </div>}
            </ul>
        </div>
    )
}

export { ChatResponse };



// WEBPACK FOOTER //
// ./src/components/message-components/chat-response.component.js